export default "<app-nav *ngIf=\"loggedIn()\"></app-nav>\n<div class=\"container-fluid\">\n  <router-outlet></router-outlet>\n</div>\n"